import React, { useCallback } from 'react';

import GenericAsyncSelect from './GenericAsyncSelect';

const createPagerDutyReferenceSelect = (requestMethod, additionalParams) => {
  const { hasIcons } = additionalParams || {};

  return ({ rawRecordToOption, ...props }) => {
    const recordToOption = useCallback((record) => {
      const findIcon = () => {
        if (!hasIcons) return undefined;
        if (record.avatar_url) return record.avatar_url;
        if (record.color) return `rect_color_${record.color}`;
        return undefined;
      };

      if (rawRecordToOption) return rawRecordToOption(record);
      return ({
        id: record.id,
        type: ((typeof record.type === 'string' && record.type.includes('_reference')) ? record.type : `${record.type}_reference`),
        email: record.email,
        label: record.name || record.title || record.summary,
        html_url: record.html_url,
        icon: findIcon()
      });
    }, [rawRecordToOption]);

    const loadOptions = useCallback(async filter => {
      let results = await requestMethod(filter);
      if (results && !Array.isArray(results) && typeof results === 'object') {
        results = Object.values(results).find(o => Array.isArray(o)) || [];
      }
      return results.map(recordToOption);
    }, [recordToOption]);

    return (
      <GenericAsyncSelect
        loadOptions={loadOptions}
        {...additionalParams}
        {...props}
      />
    );
  };
};

export { createPagerDutyReferenceSelect };
